<div class="mt-4 mb-4" *ngIf="reference">
  <div class="d-flex">
    <ol class="flex-fill breadcrumb bg-white">
      <li class="breadcrumb-item"><button class="btn btn-sm btn-link" [routerLink]="['/inventory/reference']">Références</button></li>
      <li class="breadcrumb-item active"><button class="btn btn-sm btn-link" disabled>{{ reference.isbn }} ({{ reference.title }})</button></li>
    </ol>
    <div class="pt-3 pr-3 mb-3 bg-white"><reference-inventory [reference]="reference"></reference-inventory> en stock sur Shopify</div>
  </div>
</div>
<!--

export class SupplierReference {
  active!: boolean
  supplier!: Supplier
  supplierCode!: string
  supplierRole!: string
  status!: string
  dates!: Map<string, Date>
  retailPrice!: number
  taxes!: Map<string, string>
}
-->

<div *ngIf="reference">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a 
        class="nav-link"
        routerLinkActive="active"
        [queryParams]="{tab: 'reference'}" 
        [routerLink]="['/inventory/reference', reference.isbn]" 
      >Fiche</a>
    </li>
    <li class="nav-item">
      <a 
        class="nav-link" 
        routerLinkActive="active"
        [queryParams]="{tab: 'inventory'}" 
        [routerLink]="['/inventory/reference', reference.isbn]" 
      >Inventaire</a>
    </li>
  </ul>

  <div class="p-3 border-left border-right bg-white">
    <ng-container *ngIf="activeTab == 'reference'">
      <div class="form-row">
        <div class="form-group col-xl-4">
          <div class="bg-light p-2 rounded"> 
            <label><strong>ISBN</strong></label>
            <input type="text" readonly class="form-control-plaintext" [(ngModel)]="reference.isbn">
          </div>
        </div>
        <div class="form-group col-xl-4">
          <div class="bg-light p-2 rounded"> 
            <label><strong>Titre</strong></label>
            <input type="text" class="form-control" [(ngModel)]="reference.title">
          </div>
        </div>

        <div class="form-group col-xl-2">
          <div class="bg-light p-2 rounded"> 
            <label><strong>Fournisseur</strong></label>
            <input type="text" class="form-control-plaintext" readonly [(ngModel)]="supplierReference.supplier.name" *ngIf="supplierReference">
            <input type="text" class="form-control-plaintext" readonly value="Aucun" *ngIf="!supplierReference">
            <button class="btn btn-sm btn-primary" (click)="openSwitchSupplierModal()">Changer</button>
          </div>
        </div>

        <div class="form-group col-xl-2">
          <div class="bg-light p-2 rounded"> 
            <label><strong>Prix</strong></label>
            <div class="input-group" *ngIf="supplierReference">
              <div class="input-group-prepend">
                <span class="input-group-text">$</span>
              </div>
              <input *ngIf="!overrideRetailPrice" type="text" class="form-control" disabled="disabled" readonly [value]="(supplierReference.retailPriceOverride || supplierReference.retailPrice) / 100">
              <input *ngIf="overrideRetailPrice" type="text" class="form-control" [(ngModel)]="retailPriceOverride">
              <div class="input-group-append">
                <button *ngIf="!overrideRetailPrice" class="btn btn-outline-secondary" (click)="editRetailPriceOverride()"><i class="bi bi-pencil-square"></i></button>
                <button 
                  *ngIf="!overrideRetailPrice && supplierReference.retailPriceOverride != null && supplierReference.retailPriceOverride != supplierReference.retailPrice" 
                  class="btn btn-outline-secondary" 
                  (click)="removeRetailPriceOverride()">
                  <i *ngIf="!updatingRetailPrice" class="bi bi-trash"></i>
                  <span *ngIf="updatingRetailPrice" class="spinner-border spinner-border-sm"></span>
                </button>
                <button *ngIf="overrideRetailPrice" class="btn btn-success" [attr.disabled]="updatingRetailPrice ? 'disabled' : null" (click)="updateRetailPriceOverride()">
                  <i *ngIf="!updatingRetailPrice" class="bi bi-check"></i>
                  <span *ngIf="updatingRetailPrice" class="spinner-border spinner-border-sm"></span>
                </button>
                <button *ngIf="overrideRetailPrice" class="btn btn-outline-secondary" [attr.disabled]="updatingRetailPrice ? 'disabled' : null" (click)="cancelRetailPriceOverride()"><i class="bi bi-x"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group col-12 col-xl-4">
          <div class="bg-light p-2 rounded"> 
            <label><strong>Auteurs</strong></label>
            <string-array [(value)]="reference.authors"></string-array>
            <div>
              <button class="btn btn-sm btn-primary"(click)="reference.authors.push('')">Ajouter</button>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-4">
          <div class="bg-light p-2 rounded">
            <div class="form-group">
              <label><strong>Genre Thema</strong></label>
              <div>
                <button class="btn btn-outline-secondary">
                  <ng-container *ngIf="reference.genre">
                    {{ reference.genre.nameFr }}
                  </ng-container>
                  <ng-container *ngIf="!reference.genre">
                    Aucun thème définit
                  </ng-container>
                </button>
              </div>
            </div>

            <div class="form-group"> 
              <label><strong>Genre Électre</strong></label>
              <div>
                <button class="btn btn-outline-secondary">
                  <ng-container *ngIf="reference.electreTheme">
                    {{ reference.electreTheme.fullNameFr }}
                  </ng-container>
                  <ng-container *ngIf="!reference.electreTheme">
                    Aucun thème définit
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-xl-4">
          <div class="form-group bg-light p-2 rounded">
            <label><strong>Collections</strong></label>
            <string-array [(value)]="reference.collection"></string-array>
            <div>
              <button class="btn btn-sm btn-primary" (click)="reference.collection.push('')">Ajouter</button>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row mt-2">
        <div class="col-md-4">
          <div class="form-group bg-light p-2 rounded">
            <label><strong>Éditeur</strong></label>
            <input type="text" class="form-control" [(ngModel)]="reference.publisher">
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group bg-light p-2 rounded">
            <label><strong>Parution canadienne</strong></label>
            <div class="input-group">
              <input class="form-control" placeholder="AAAA-MM-JJ" [(ngModel)]="publishDateCA" ngbDatepicker #caDatePicker="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="caDatePicker.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group bg-light p-2 rounded">
            <label><strong>Parution française</strong></label>
            <div class="input-group">
              <input class="form-control" placeholder="AAAA-MM-JJ" [(ngModel)]="publishDateFR" ngbDatepicker #frDatePicker="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="frDatePicker.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="col-12">
          <div class="form-group bg-light p-2 rounded">
            <label><strong>Descriptif</strong></label>
            <textarea class="form-control" rows="5">{{ reference.description }}</textarea>
          </div>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="activeTab == 'inventory'">
      <div class="pb-3 text-right">
        <button class="btn btn-sm btn-primary" (click)="openNewInventoryAdjustmentModal()">Ajustement</button>
      </div>
      <table class="table table-sm" *ngIf="inventoryMovements">
        <thead>
          <tr>
            <th>Source</th>
            <th class="text-center">Quantité</th>
            <th class="text-center">Date</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let inventoryMovement of inventoryMovements.content">
            <td>
              <ng-container *ngIf="inventoryMovement.inventoryAdjustmentId">
                <button class="btn btn-sm btn-link disabled">
                  <span class="text-primary">Ajustement - {{ inventoryMovement.inventoryAdjustmentComment }}</span>
                </button>
              </ng-container>
              <ng-container *ngIf="inventoryMovement.receptionId">
                <button 
                  class="btn btn-sm btn-link" 
                  [routerLink]="['/inventory/reception', inventoryMovement.receptionId]"
                >
                  Réception {{inventoryMovement.receptionConfirmTimestamp | date : "yyyy/MM/dd, HH:mm" }}
              </button>
              </ng-container>
              <ng-container *ngIf="inventoryMovement.customerOrderId">
                <button class="btn btn-sm btn-link">
                  <a 
                    [attr.href]="companyInfo.shopifyAdminUrl + '/orders/' + inventoryMovement.customerOrderId" 
                    target="_blank"
                  >
                    Vente {{inventoryMovement.customerOrderNumber}}
                    <span><img class="shopify" src="/assets/icons/shopify.png"></span>
                  </a>
                </button>
              </ng-container>
              <ng-container *ngIf="inventoryMovement.rmaNumber">
                <button 
                  class="btn btn-sm btn-link" 
                  [routerLink]="['/inventory/rma', inventoryMovement.rmaNumber]"
                >
                  Retour Fournisseur {{inventoryMovement.rmaNumber}}
              </button>
              </ng-container>
            </td>
            <td class="text-center">
              {{ inventoryMovement.quantity }}
            </td>
            <td class="text-center">{{ inventoryMovement.creationTimestamp | date : "yyyy/MM/dd, HH:mm"  }}</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
</div>